import React from 'react';

import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { Button } from '@/uiKit/atoms/Button.tsx';
import { CardFooter } from '@/uiKit/atoms/card/CardFooter.tsx';
import { PatientCreationInfo } from '@/uiKit/organisms/PatientCreationAndRenewal/PatientInfo/PatientCreationInfo.ts';
import { PATIENT_INFO_FORM_ID } from '@/uiKit/organisms/PatientCreationAndRenewal/PatientInfo/PatientInfoForm.tsx';

export type PatientInfoFormActionsProps = {
  onBack?: (data: Partial<PatientCreationInfo>) => void;
};

export const PatientInfoFormActions: React.FC<PatientInfoFormActionsProps> = ({
  onBack,
}) => {
  const { t } = useTranslation();
  const formContext = useFormContext<PatientCreationInfo>();

  return (
    <CardFooter>
      <Button
        variant="outlined"
        id="patient-info-cancel"
        onClick={() => onBack && onBack(formContext.getValues())}
      >
        {t('button.cancel')}
      </Button>
      <Button
        form={PATIENT_INFO_FORM_ID}
        id="patient-info-next"
        type="submit"
        variant="contained"
      >
        {t('button.next')}
      </Button>
    </CardFooter>
  );
};
